import SearchBar from 'components/Autosuggest/Autosuggest';
import Currency from 'components/Currency/Currency';
import DecimalInput from 'components/DecimalInput';
import WholeNumberInput from 'components/WholeNumberInput';
import React, { useEffect, useState } from 'react';
import { searchUserByName } from 'services/api/common';
import { searchItems } from 'services/api/inventoryItems';
import { createUserInventoryMapping, updateUserInventoryMapping } from 'services/api/userInventoryMapping';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AddUserInventoryItemModal = props => {
  const [discountPercent, setDiscountPercent] = useState<number>(0);
  const [fixedDiscountAmount, setFixedDiscountAmount] = useState<number>(0);
  const [name, setName] = useState<string>('');
  const [userName,setUserName] = useState<string>('');
  const [user, setUser] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [item, setItem] = useState<Record<string, any>>({});
  const [itemSelected, setItemSelected] = useState<boolean>(false);
  const { id,originalDiscountPercent,originalFixedDiscountAmount } = props.selectedUserMapping;
  const {
    isEdit,
    isUser,
    isUserPage,
    userId,
    selectedItemToUpdate,
    selectedUserMapping,
    toggleModal,
    inventoryItemId,
    onSuccess,
  } = props;

  useEffect(()=>{
    if (!!Object.keys(selectedUserMapping).length) {
      setDiscountPercent(originalDiscountPercent);
      setFixedDiscountAmount(originalFixedDiscountAmount);
    }
  },[]);

  const addInventoryItem = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    setLoading(true);
    const selectedUserId= isUser?user:userId;
    const selectedInventoryItemId = isUser?inventoryItemId:item.id; 
    const data = {
      userId:selectedUserId,
      inventoryItemId:selectedInventoryItemId,
      discountPercent,
      fixedDiscountAmount,
    };
    try {
      await createUserInventoryMapping(data);
      showSuccess('Mapping added successfully');
      await onSuccess();
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  const updateInventoryItem = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      userId,
      id,
      discountPercent,
      fixedDiscountAmount,
    };
    try {
      await updateUserInventoryMapping(data);
      showSuccess('Mapping upated successfully');
      await onSuccess();
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const onClickSubmit = async (e) => {
    if (isEdit) {
      updateInventoryItem(e);
    } else {
      addInventoryItem(e);
    }
  };

  const handleSuggestionClick = async (item) => {
    setItem(item);
    setItemSelected(true);
  };

  const ItemInfo = () => (
    <div className={styles['item-details']}>
      {item.image && (
        <div className={styles['item-image']}>
          <img src={item.image} />
        </div>
      )}
      <div>
        <div className={styles['item-name-section']}>
          <div className={styles['label']}>{isEdit ? `User Name` : `Item Name`}</div>
          <div className={styles['item-name']}>{item.displayName || 'N/A'}</div>
        </div>
        <div className={styles['category-section']}>
          <div className={styles['label']}>Category</div>
          <div className={styles['item-category']}>{item.category?.displayName || 'N/A'}</div>
        </div>
        <div className={styles['price-section']}>
          <div className={styles['label']}>Price</div>
          <div className={styles['item-price']}>{<Currency amount={item.price} />}</div>
        </div>
      </div>
    </div>
  );

  const getHeading=()=>{
    const heading=isEdit ? 'User' : 'Inventory Item';
    return (
      <div className={styles['label']}>{heading}Mapping</div>
    );
  };

  const getSubHeading=()=>{
    const subHeading=isEdit ? 'Update User' : 'Add A New Inventory Item';
    return (           
      <div className={styles['modal-title']}>{subHeading}Mapping</div>
    );
  };

  const getHeader=()=>{
    return (
      <div className={styles['modal-header']}>
        <div>
          {getHeading()}
          {getSubHeading()}
        </div>
        <i className={'fa fa-times'} onClick={toggleModal} />
      </div>
    );
  };

  const getInputName=()=>{
    return (
      <div className={styles['label']}>{isEdit || isUser ? `User Name` : `Item Name` }</div>
    );
  };

  const getSearchInventoryItem=()=>{
    return (
      <SearchBar
        value={name}
        setValue={value => setName(value)}
        clearOnSelect={false}
        searchAPI={searchItems}
        searchAPIParamKey={'term'}
        onSuggestionClicked={handleSuggestionClick} /> 
    );
  };

  const getSearchUserInput=()=>{
    return (
      <SearchBar
        isUser={true}
        value={userName}
        // eslint-disable-next-line @typescript-eslint/camelcase
        setValue={value => setUserName(value)}
        searchAPI={searchUserByName}
        searchAPIParamKey={'searchTerm'}
        onSuggestionClicked={(e)=>setUser(e.objectId)}
      />
    );
  };

  const handleDiscountPercentChange=(value: number)=>{
    if(!value){
      setDiscountPercent(0);
    }else{
      setDiscountPercent(value);
      setFixedDiscountAmount(0);
    }
  };

  const getDiscountPercent=()=>{
    return (
      <div className={'mb-3'}>
        <div className={styles['label']}>Discount Percent</div>
        <WholeNumberInput
          className={'form-control'}
          value={discountPercent}
          disabled={loading}
          onChange={handleDiscountPercentChange} />
      </div>);
  };

  const handleFixedDiscountAmountChange=(value: number)=>{
    if(!value){
      setFixedDiscountAmount(0);
    }else{
      setFixedDiscountAmount(value);
      setDiscountPercent(0);
    }
  };

  const getfixedDiscountAmount=()=>{
    return (
      <div>
        <div className={styles['label']}>Fixed Discount</div>
        <DecimalInput
          className={'form-control'}
          value={fixedDiscountAmount}
          disabled= {loading}
          onChange={handleFixedDiscountAmountChange} />
      </div>
    );
  };

  const getSuggestionInput=()=>{
    return (
      <div className={styles['autosuggest-container']}>
        {!isUser && !isUserPage && (isEdit ? ( <input className='form-control' value={selectedItemToUpdate} disabled />):
          (getSearchInventoryItem()))}  
        {isUser && getSearchUserInput()}
        {isUserPage && getSearchInventoryItem()}
      </div>
    );
  };

  const getItemSelected=()=>{
    if(itemSelected){
      return <ItemInfo/>;
    }
    else{
      return null;
    }
  };

  const getFooter=()=>{
    return (
      <div className={styles['modal-footer']}>
        <button
          className={styles['cancel-button']}
          onClick={toggleModal}
          disabled={loading}
        >
            Cancel
        </button>
        <button
          onClick={onClickSubmit}
          className={styles['submit-button']}
          disabled={loading}
        >
            Submit
        </button>
      </div>
    );
  };

  const getModalBody=()=>{
    return (
      <div className={styles['modal-body']}>
        <div className={'mb-3'}>
          {getInputName()}
          {getSuggestionInput()}
        </div>
        <div>
          {getDiscountPercent()}
          {getfixedDiscountAmount()}
        </div>
        {getItemSelected()}
      </div>
    );
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        {getHeader()}
        {getModalBody()}
        {getFooter()}
      </div>
    </div>
  );
};

export default AddUserInventoryItemModal;
